<template>
  <ai-hero
    :breadcrumb-items="breadcrumbItems"
    :variant="variant"
    :city-label="cityLabel"
    :country-label="countryLabel"
    :number-of-star="numberOfStar"
    :experience-categories="experienceCategories"
    :rating="rating"
    :reviews="reviews"
    :display-video="false"
    :hero-title="hotelName"
    :hotel-brand-code="hotelBrandCode"
    :hero-image="hotelImage"
    :hero-video="hotelVideo"
    :hotel-slug="hotelSlug"
    hotel-page>
    <template #header>
      <div class="HotelHero-header" />
    </template>
  </ai-hero>
</template>

<script setup lang="ts">
import type { ExperienceCategories } from '~~/domains/ux/molecules/AiHero/AiHero.vue';
import type { AiPicture } from '~~/domains/graphql';
import type { BrandCode } from '~~/domains/ux/atoms/AiLogo/AiLogo.vue';
import type { BreadcrumbItem } from '~~/domains/ux/molecules/AiBreadcrumb/AiBreadcrumb.vue';

interface HotelHeroProps {
  breadcrumbItems: BreadcrumbItem[];
  cityLabel: string;
  countryLabel: string;
  hotelBrandCode?: BrandCode | string | null;
  hotelName: string;
  numberOfStar: number;
  experienceCategories: ExperienceCategories[];
  rating?: number;
  reviews?: number;
  variant: 'positive' | 'inverse';
  hotelImage: AiPicture;
  hotelVideo?: AiPicture | null;
  hotelSlug: string;
}
defineProps<HotelHeroProps>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';

.HotelHero-header {
  margin-top: constants.$header-large;
  @media (mq.$from-medium) {
    margin-top: calc(constants.$header-subheader-large + constants.$margin-01);
  }
}
</style>
